
<div class="header-toolbar">
  <h1>
    {{ execution?.operation.name }}
    <span>({{ execution?.revision.fullname }})</span>
  </h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="execution">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <a class="btn" (click)="downloadAll()">
      <t-icon name="file_download"></t-icon>
      <span class="text">Télécharger tout</span>
    </a>

  </div>
  <!-- /Toolbar -->

  <div class="grid">

    <div class="column">

      <div class="panel">
        <h2>
          Documents
        </h2>

        <t-download-tree [execution]="execution" (downloaded)="downloadOne($event)"></t-download-tree>

      </div>
      
    </div>

    <div class="column">

      <div class="panel">
        <h2>
          Champs supplémentaires
        </h2>

        <div class="empty-table compact" *ngIf="execution.fields_model.length === 0">
          <p>Aucun champ supplémentaire trouvé</p>
        </div>

        <ng-container *ngIf="execution.fields_model.length > 0">
          <div class="btn-toolbar">

            <button class="btn btn-small btn-gray" [disabled]="!fieldsChanged">
              <t-icon name="check"></t-icon>
              <span class="text">Enregistrer</span>
            </button>

            &nbsp;

            <button class="btn btn-small btn-gray" (click)="cancel()" [disabled]="!fieldsChanged">
              <t-icon name="close"></t-icon>
              <span class="text">Annuler</span>
            </button>
          </div>

          <t-execution-form [(fields)]="execution.fields"></t-execution-form>
        </ng-container>
      </div>


      <div class="panel">
        <h2>
          Dossiers supplémentaires
        </h2>

        <table>
          <thead>
            <tr>
              <th style="border-top-left-radius: 0">Champ racine</th>
              <th style="width: 250px; border-top-right-radius: 0">Dossier assigné</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dossier of execution.dossiers">
              <td name="Champ racine">
                {{ dossier.root_field || '[par défaut]' }}
              </td>
              <td name="Dossier assigné" style="width: 250px">
                {{ dossier?.dossier?.name || '-' }}
              </td>
            </tr>
          </tbody>
        </table>

      </div>

    </div>

  </div>
</form>